.notice {
  display: grid;
  gap: var(--space-3);
  max-width: var(--measure-prose);
  padding: var(--space-4);
  border: 1px solid var(--line-strong);
  border-left: 3px solid var(--positive);
  border-radius: var(--radius-md);
  background: var(--surface-inset);
}

.heading {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
}

.heading > div {
  display: grid;
  gap: var(--space-1);
  min-width: 0;
}

.mark {
  display: grid;
  place-items: center;
  width: var(--space-6);
  height: var(--space-6);
  flex: 0 0 auto;
  border: 1px solid var(--positive);
  border-radius: var(--radius-pill);
  color: var(--positive);
  font-family: var(--font-display);
  font-weight: 700;
}

.eyebrow {
  color: var(--ink-muted);
  font-family: var(--font-display);
  font-size: var(--text-2xs);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
}

.title {
  color: var(--ink-primary);
  font-family: var(--font-display);
  font-size: var(--text-sm);
  overflow-wrap: anywhere;
}

.summary,
.outcome {
  margin: 0;
  color: var(--ink-secondary);
  font-size: var(--text-sm);
  line-height: var(--leading-relaxed);
  overflow-wrap: anywhere;
}

.categories {
  display: grid;
  gap: var(--space-1);
  margin: 0;
  padding-left: var(--space-5);
  color: var(--ink-primary);
  font-size: var(--text-sm);
}

.categories li::marker {
  color: var(--positive);
}

.outcome {
  padding-top: var(--space-3);
  border-top: 1px solid var(--line-subtle);
}
